import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import queryString from 'query-string';
import { ClockIcon, MapIcon, StarIcon } from '@heroicons/react/24/outline';
import useRouter from '@/hooks/useRouter';
import DropdownFilter from '@/components/DropdownFilter';

SortBy.propTypes = {
  withDistance: PropTypes.bool,
  withBeginning: PropTypes.bool,
  withExpiring: PropTypes.bool,
  withFeatured: PropTypes.bool,
  defaultOrder: PropTypes.string,
};

export default function SortBy(props) {
  const {
    withDistance = false,
    withBeginning = true,
    withExpiring = true,
    withFeatured = false,
    defaultOrder = 'Newest',
  } = props;

  const { location, history } = useRouter();

  const search = queryString.parse(location.search);

  function onChange(order) {
    const search = queryString.parse(location.search) || {};

    search.order = order;
    delete search.page;

    history.push({
      pathname: location.pathname,
      search: queryString.stringify(_.extend({}, search))
    });
  }

  const orderMap = {
    Featured: {
      name: 'Featured',
      param: 'featuredAt DESC NULLS LAST, createdAt DESC'
    },
    Newest: {
      name: 'Newest',
      param: 'createdAt desc'
    },
    Beginning: {
      name: 'Start date',
      param: 'startDate asc'
    },
    Expiring: {
      name: 'Expiring',
      param: 'endDate asc'
    },
    Distance: {
      name: 'Distance',
      param: 'distance asc'
    }
  };

  const reverseOrderMap = _.mapKeys(orderMap, function(value) {
    return value.param;
  });

  return (
    <DropdownFilter subtitle="Sort by:" title={reverseOrderMap[search.order]?.name || defaultOrder }>
      {withFeatured && (
        <DropdownFilter.MenuItem
          icon={StarIcon}
          title={orderMap.Featured.name}
          subtitle="Display featured projects first."
          selected={(!search.order && defaultOrder === 'Featured')|| search.order === orderMap.Featured.param}
          onClick={() => onChange(defaultOrder === 'Featured' ? undefined : orderMap.Featured.param)}
        />
      )}
      <DropdownFilter.MenuItem
        icon={ClockIcon}
        title={orderMap.Newest.name}
        subtitle="Display recently created projects first."
        selected={(!search.order && defaultOrder === 'Newest')|| search.order === orderMap.Newest.param}
        onClick={() => onChange(orderMap.Newest.param)}
      />
      {withBeginning && (
        <DropdownFilter.MenuItem
          icon={ClockIcon}
          title={orderMap.Beginning.name}
          subtitle="Display projects by date they began."
          selected={search.order === orderMap.Beginning.param}
          onClick={() => onChange(orderMap.Beginning.param)}
        />
      )}
      {withExpiring && (
        <DropdownFilter.MenuItem
          icon={ClockIcon}
          title={orderMap.Expiring.name}
          subtitle="Display the projects expiring soon first."
          selected={search.order === orderMap.Expiring.param}
          onClick={() => onChange(orderMap.Expiring.param)}
        />
      )}
      {withDistance && (
        <DropdownFilter.MenuItem
          icon={MapIcon}
          title={orderMap.Distance.name}
          subtitle="Display projects near you first."
          selected={search.order === orderMap.Distance.param}
          onClick={() => onChange(orderMap.Distance.param)}
        />
      )}
    </DropdownFilter>
  );
}
